import React from 'react';
import { QualityLabel as StyledQualityLabel } from './QualityLabel.styled';

export interface QualityLabelProps {
  children: React.ReactNode;
  className?: string;
}

export function QualityLabel({ children, className }: QualityLabelProps) {
  return (
    <StyledQualityLabel className={className}>
      {children}
    </StyledQualityLabel>
  );
}
